export const SIDEBAR_OPEN_STATE_KEY = 'sidebar_open_state';
export const CURRENT_WELL = 'currentWell';
export const ONBOARDING = {
  EDDR_OVERVIEW: 'shouldDisplayEddrOverviewOnboarding',
};
export const HIDDEN_WEB_INCIDENTS = 'hiddenWebIncidents';

export default class LocalStorer {
  static set(key: string, data: string): void {
    localStorage.setItem(key, data);
  }

  static get(key: string): string | null {
    return localStorage.getItem(key);
  }
}
